import React from "react";
import { Route, Routes } from "react-router-dom";
import AboutUs from "../pages/AboutUs";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsAndCondition from "../pages/TermsAndCondition";
import Home from "../pages/Home";
import CourseDetails from "../pages/CourseDetails";
import BecomePartner from "../pages/BecomePartner";
import SuccessStoriesPage from "../pages/SuccessStories/SuccessStories";
import ExploreOurCourses from "../pages/ExploreOurCourses";
import Blogs from "../pages/Blogs";
import BlogSearch from "../pages/BlogSearch";
import BlogPost from "../pages/BlogPost";
import RiseupEvent from "../pages/RiseupEvent";
import DashboardHome from "../pages/dashboard/DashboardHome";
import ProtectedLayout from "../layouts/ProtectedLayout";
import PublicLayout from "../layouts/PublicLayout";

const publicRoutes = [
  {
    key: "Home",
    path: "/",
    element: <Home />,
  },
  {
    key: "AboutUs",
    path: "/about-us",
    element: <AboutUs />,
  },
  {
    key: "PrivacyPolicy",
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    key: "TermsAndCondition",
    path: "/terms-and-conditions",
    element: <TermsAndCondition />,
  },
  {
    key: "CourseDetails",
    path: "/program/:id",
    element: <CourseDetails />,
  },
  {
    key: "BecomePartner",
    path: "/becomePartner",
    element: <BecomePartner />,
  },
  {
    key: "SuccessStoriesPage",
    path: "/successStoriesPage",
    element: <SuccessStoriesPage />,
  },
  {
    key: "ExploreOurCourses",
    path: "/ExploreOurCourses",
    element: <ExploreOurCourses />,
  },

  {
    key: "Blogs",
    path: "/blogs",
    element: <Blogs />,
  },
  {
    key: "BlogSearch",
    path: "/blogSearch",
    element: <BlogSearch />,
  },
  {
    key: "BlogPost",
    path: "/blogs/:id",
    element: <BlogPost />,
  },
  {
    key: "RiseupEvent",
    path: "/events",
    element: <RiseupEvent />,
  },
];

const protectedRoutes = [
  {
    key: "DashboardHome",
    path: "/dashboard",
    element: <DashboardHome />,
  },
];

const AllRoute = () => {
  return (
    <Routes>
      {publicRoutes.map((publicRoute) => {
        return (
          <Route
            key={publicRoute.key}
            path={publicRoute.path}
            element={<PublicLayout>{publicRoute.element}</PublicLayout>}
          />
        );
      })}

      {protectedRoutes.map((protectedRoute) => {
        return (
          <Route
            key={protectedRoute.key}
            path={protectedRoute.path}
            element={
              <ProtectedLayout>{protectedRoute.element}</ProtectedLayout>
            }
          />
        );
      })}
    </Routes>
  )
}

export default AllRoute

